(function () {
  const button = document.getElementById('ScrollToTop');
  if (!button) return;

  let lastScrollY = window.scrollY;

  function onScroll() {
    const scrollY = window.scrollY;
    const scrollingUp = scrollY < lastScrollY;

    button.classList.toggle('scroll-to-top-button--visible', scrollingUp && scrollY > 0);

    lastScrollY = scrollY;
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
